import React, { useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import PasswordBtn from './passwordbtn';
import { useContext, useState } from 'react';
import Loader from "../Loader/loader";
import { ThemeProvider, useTheme } from '@mui/material/styles';
import { customTheme } from '../theme/textfieldTheme';

import { AuthContext } from '../../contexts/auth';
import ColorButton from '../Buttons/ColorButton';
import { Box } from '@mui/material';

const InputsLogin = ({redirect=true}) => {

    const [loading, setLoading] = useState(false)
    const [engine, setEngine] = useState('ELEVOR')
    const { login } = useContext
        (AuthContext);

    const [username, setUser] = useState("")
    const [password, setPassword] = useState("")

    useEffect(()=>{
        if (engine)
            localStorage.setItem('v10-default-engine', engine)
    }, [engine])

    const submitHandler = async (e) => {
        e.preventDefault()

        setLoading(true)
        await login(username, password, engine, redirect)
        setLoading(false)
    }

    const changeUserHandler = (e) => {
        setUser(e.target.value)
    }

    const changePassowrdHandler = (e) => {
        setPassword(e.target.value)
    }

    const outerTheme = useTheme();

    return (

        <section>
            <Loader external show={loading} />
            <form onSubmit={submitHandler}>
                <div className="items-center">

                    <ThemeProvider theme={customTheme(outerTheme)}>
                        <div>
                            <TextField
                                size='small'
                                id="txtUserName"
                                margin="normal"
                                required
                                fullWidth
                                label="Usuário"
                                name="usuario"
                                type="text"
                                value={username}
                                onChange={changeUserHandler}
                            />
                        </div>

                        <div className="items-top">
                            <PasswordBtn  passProp={password} changePass={changePassowrdHandler} />
                        </div>
                        {/* <Box className='multi-select-box'>
                            <ColorButton reverse={engine!=='MICROUNIVERSO'} onClick={()=>setEngine('MICROUNIVERSO')}>
                                MICROUNIVERSO
                            </ColorButton>
                            <ColorButton reverse={engine!=='ELEVOR'} onClick={()=>setEngine('ELEVOR')}>
                                ELEVOR
                            </ColorButton>
                        </Box> */}

                    </ThemeProvider>

                    <div className="items-top">
                        <Button
                            style={{
                                backgroundColor: "rgb(236 27 38)"
                            }}
                            type="submit"
                            variant="contained"
                            fullWidth
                            color="secondary"
                            size="medium"
                            className="mb-3 mb-md-4 md-4"
                        >
                            Entrar
                        </Button>
                    </div>

                </div>
            </form>
        </section>

    )
};

export default InputsLogin;